/* eslint-disable no-use-before-define,jsx-a11y/anchor-is-valid */
import React from 'react'
import { show, showModal, publish } from '../twd'
import Alerts from './alerts'

export default () => {

   return (
    <div className="text-right space-around">

    <a href='#'
        data-name="orders-link"
        style={{marginRight:'5px'}}
        className="btn btn-link"
        onClick={() => {
            publish('orders_reset_filters')
            show('orders', {_ts:Date.now()})
        }}
    >Orders</a>

    <button
        data-name="holdings-link"
        style={{marginRight:'5px'}}
        className="btn btn-link"
        onClick={(e) => showModal('holdings', { source:e.target, })}
    >Holdings</button>


    <Alerts />
    </div>)
}
